import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { RankingConstants } from "../../constants/RankingConstants";
import { IdStyles } from "../../less/IdStyles";
import { selectOngoingPlayerProfileInfo } from "../../selectors/selectOngoingPlayerProfileInfo";
import { selectPlayerInfo } from "../../selectors/selectPlayerInfo";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { DialogWrapper } from "../dialog/DialogWrapper";
import { actionModalClose } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { PlayerProfileAwardsArea } from "./PlayerProfileAwardsArea";
import { PlayerProfileInfoArea } from "./PlayerProfileInfoArea";
export var _DialogPlayerProfile = function (_a) {
    var ongoingPlayerProfile = _a.ongoingPlayerProfile, onClose = _a.onClose, ownId = _a.ownId;
    var id = ongoingPlayerProfile.id, coopInfo = ongoingPlayerProfile.coopInfo, profileIcon = ongoingPlayerProfile.profileIcon, name = ongoingPlayerProfile.name, level = ongoingPlayerProfile.level;
    var countStars = function (stars, divisor) {
        var rawStars = stars % divisor;
        return rawStars === 0 ? divisor : rawStars;
    };
    var playerId = id === ownId ? undefined : id;
    var playerLeagueDivision = ongoingPlayerProfile.playerLeagueId;
    var coopLeagueDivision = ongoingPlayerProfile.coopInfo !== undefined &&
        ongoingPlayerProfile.coopInfo.coopLeagueId !== undefined
        ? ongoingPlayerProfile.coopInfo.coopLeagueId
        : undefined;
    var playerLeagueStars = countStars(ongoingPlayerProfile.playerLeagueId, RankingConstants.NumberPlayerLeagueDivisions);
    var coopLeagueStars = coopLeagueDivision !== undefined
        ? countStars(coopLeagueDivision, RankingConstants.NumberCoopDivisions)
        : 0;
    return (React.createElement(DialogWrapper, { titleLocaId: IdLoca.profileDialog_title, onClose: function () { return onClose(IdModal.PlayerProfile); }, className: "" + IdStyles.ModalBackgroundInfo },
        React.createElement("div", { className: "w100 h100 flex flex--around flex--aligned" },
            React.createElement(PlayerProfileInfoArea, { playerIcon: profileIcon, playerName: name, playerLevel: level, coopInfo: coopInfo, playerId: playerId }),
            React.createElement(PlayerProfileAwardsArea, { coopLeagueCupIndex: coopLeagueDivision, coopLeagueStars: coopLeagueStars, playerLeagueCupIndex: playerLeagueDivision, playerLeagueStars: playerLeagueStars }))));
};
var mapState = function (state) { return ({
    ongoingPlayerProfile: selectOngoingPlayerProfileInfo(state),
    ownId: selectPlayerInfo(state).playerId,
}); };
var mapDispatch = function (dispatch) {
    return bindActionCreators({
        onClose: actionModalClose,
    }, dispatch);
};
export var DialogPlayerProfile = connect(mapState, mapDispatch)(_DialogPlayerProfile);



//////////////////
// WEBPACK FOOTER
// ./src/features/player-profile/DialogPlayerProfile.tsx
// module id = 2871
// module chunks = 3